import { render, staticRenderFns } from "./Cricket.vue?vue&type=template&id=2089a070&"
import script from "./Cricket.vue?vue&type=script&lang=js&"
export * from "./Cricket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports